import React from 'react'
import { array, bool } from 'prop-types'

import Grid from '../../Grid'
import Card from '../../Card'
import Surround from '../../Surround'
import Tag from '../../Tag'

const CardGrid1 = ({ articles, displayCategory }) => {
  if (!articles.length) return null
  const topGridArticles = articles.slice(1, 4)
  const imageRatio = 126 / 167
  return (
    <Grid flex gutter="default">
      <Grid.Item trailingGap="mobile" width={{ d: 1 / 3 }}>
        <Card
          typeConfig={{
            title: { size: ['heading7', 'heading4'], themed: true }
          }}
          inverse={articles[0].featured}
          inset={articles[0].featured}
          headerComponents={() => {
            if (!articles[0].featured) return null
            return <Tag background="white">Featured</Tag>
          }}
          {...{
            ...articles[0],
            sizes: [
              '(min-width: 1440px) 290px',
              // 168 = padding within column (2 * 16px) + padding between columns (3 * 24px) + content gutter (64px)
              '(min-width: 960px) calc(25vw - 168px)',
              'calc(100vw - 32px)'
            ]
          }}
          imageRatio={imageRatio}
        />
      </Grid.Item>
      <Grid.Item width={{ d: 2 / 3 }}>
        <Grid flex gutter="default">
          {topGridArticles.map((article, i) => {
            const typeConfig = {
              title: {
                size: 'heading7',
                themed: true
              },
              description: {
                size: ['body2', 'body4']
              }
            }
            return (
              <Grid.Item
                key={i}
                trailingGap="default"
                width={{ d: 1 / 3 }}
                hidden={i === 2 ? 'mobile' : null}
              >
                <Surround padded="default" bordered="default">
                  <Card
                    typeConfig={typeConfig}
                    footerComponents={() => {
                      if (!article.category || !displayCategory) return null
                      return <Tag>{article.category}</Tag>
                    }}
                    {...{
                      ...article,
                      sizes: [
                        '(min-width: 1420px) 206px',
                        '(min-width: 960px) calc(16.6666vw - 80px)',
                        'calc((100vw - 80px) * 0.5)'
                      ],
                      width: 206
                    }}
                    imageRatio={imageRatio}
                  />
                </Surround>
              </Grid.Item>
            )
          })}

          {articles[4] && (
            <Grid.Item trailingGap="mobile" width={{ d: 1 / 2 }}>
              <Surround padded="mobile" bordered="mobile">
                <Card
                  typeConfig={{
                    title: {
                      size: ['body2', 'heading8'],
                      weight: 'medium',
                      themed: true
                    }
                  }}
                  horizontal
                  footerComponents={() => {
                    if (!articles[4].category || !displayCategory) return null
                    return <Tag>{articles[4].category}</Tag>
                  }}
                  {...{
                    ...articles[4],
                    description: '',
                    sizes: [
                      '(min-width: 1420px) 138px',
                      '(min-width: 960px) calc(12.5vw - 80px)',
                      'calc(45vw - 80px)'
                    ],
                    width: 138
                  }}
                  imageRatio={imageRatio}
                />
              </Surround>
            </Grid.Item>
          )}
          {articles[5] && (
            <Grid.Item trailingGap="mobile" width={{ d: 1 / 2 }}>
              <Card
                typeConfig={{
                  title: {
                    size: ['body2', 'heading8'],
                    weight: 'medium',
                    themed: true
                  }
                }}
                horizontal
                footerComponents={() => {
                  if (!articles[5].category || !displayCategory) return null
                  return <Tag>{articles[5].category}</Tag>
                }}
                {...{
                  ...articles[5],
                  description: '',
                  sizes: [
                    '(min-width: 1420px) 138px',
                    '(min-width: 960px) calc(12.5vw - 80px)',
                    'calc(45vw - 80px)'
                  ],
                  width: 138
                }}
                imageRatio={imageRatio}
              />
            </Grid.Item>
          )}
        </Grid>
      </Grid.Item>
    </Grid>
  )
}

CardGrid1.propTypes = {
  articles: array,
  displayCategory: bool
}

export default CardGrid1
